import { createContext } from "react";
import type { Status } from "types/Status";

const OneRepMaxChartStatusContext = createContext<Status | undefined>(undefined);
OneRepMaxChartStatusContext.displayName = "OneRepMaxChartStatusContext";

export default OneRepMaxChartStatusContext;
